var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.505,
    height: 57.799,
    viewBox: "0 0 42.505 57.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M470.185,351.143a15.592,15.592,0,0,0-.921-1.788,16.678,16.678,0,0,0-5.084-5.4,18.219,18.219,0,0,0-9.736-2.843h-.018l-.013-.011h-4.725l.336-.107a16.543,16.543,0,0,0,4.492-2.214,14.545,14.545,0,0,0,4.881-5.532,12.256,12.256,0,0,0,1.182-6.634,12.726,12.726,0,0,0-2.477-6.368,16.059,16.059,0,0,0-6.147-4.807,22.857,22.857,0,0,0-9.818-1.908H429v.4A4.884,4.884,0,0,1,430.559,318v39.4A4.856,4.856,0,0,1,429,361.427v.4h5.56v-.4a4.789,4.789,0,0,1-1.556-3.921V314.042h9.2a19.442,19.442,0,0,1,6.5,1.1,13.583,13.583,0,0,1,7.461,6.2,13.336,13.336,0,0,1,0,13,13.745,13.745,0,0,1-5.037,5,17,17,0,0,1-6.733,2.126v.4c2.322.095,3.656.923,6.423,5.26,1.18,1.85,9.189,14.191,9.592,14.707h4.14v-.386c-.772-.335-1.41-.643-3.909-3.953l-11-15.7h4.338c6.246,0,9.788,3.009,11.659,5.533a16.8,16.8,0,0,1,3.176,9.505c0,5.052-2.035,8.874-6.048,11.361a18.466,18.466,0,0,1-9.283,2.542h-8.006a6.737,6.737,0,0,1-3.054-.619c-.6-.369-.908-1.339-.908-2.883l-.009-37.145a4.714,4.714,0,0,1,1.554-3.794v-.4H437.6v.4a4.6,4.6,0,0,1,1.546,3.595v36.972a4.882,4.882,0,0,1-1.558,4.076v.4h15.9c6.366,0,11.178-1.623,14.3-4.823a13.679,13.679,0,0,0,3.715-9.564A14.576,14.576,0,0,0,470.185,351.143Z",
    transform: "translate(-429 -313.53)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55000329200163a7ae95bdac3cb865e8.svg";
export { ForwardRef as ReactComponent };